import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../config"; // Ваш Firebase Auth инстанс
import { onAuthStateChanged, browserLocalPersistence, setPersistence } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("access_token_esti") || "");
    const [loading, setLoading] = useState(true); // Добавим состояние загрузки

    useEffect(() => {
        // 1. Настройка постоянства Firebase Auth
        // Это должно быть сделано один раз, обычно при инициализации приложения
        // или до первого вызова onAuthStateChanged
        const setupPersistence = async () => {
            try {
                // Выберите желаемый тип постоянства:
                // browserLocalPersistence: сохраняет сессию даже после закрытия браузера
                // browserSessionPersistence: сохраняет сессию только до закрытия вкладки/браузера
                await setPersistence(auth, browserLocalPersistence);
                console.log("Firebase Auth Persistence установлено на localStorage.");
            } catch (error) {
                // Обработка ошибок, например, если IndexedDB недоступен
                console.error("Ошибка при установке Firebase Auth Persistence:", error);
            }
        };

        setupPersistence(); // Вызываем настройку постоянства

        // 2. onAuthStateChanged теперь будет использовать кешированные данные
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);

                // Проверяем, есть ли интернет перед попыткой обновить токен
                if (navigator.onLine) {
                    try {
                        // Только обновляем токен, если есть интернет
                        const newToken = await currentUser.getIdToken(true);
                        setToken(newToken);
                        localStorage.setItem("access_token_esti", newToken);
                        console.log("Firebase токен обновлен из сети.");
                    } catch (error) {
                        // Если не удалось обновить токен (но пользователь есть), используем старый
                        console.warn("Не удалось обновить Firebase токен из сети:", error);
                        // Используем токен из localStorage, если он есть
                        setToken(localStorage.getItem("access_token_esti") || "");
                    }
                } else {
                    // Если нет интернета, используем токен из localStorage
                    setToken(localStorage.getItem("access_token_esti") || "");
                    console.log("Офлайн: Используем Firebase токен из localStorage.");
                }
            } else {
                setUser(null);
                setToken("");
                localStorage.removeItem("access_token_esti");
                console.log("Пользователь не авторизован или вышел.");
            }
            setLoading(false); // Завершаем загрузку после первой проверки состояния
        });

        return () => unsubscribe();
    }, []); // Запускаем эффект только при монтировании

    // Можно добавить слушателя для изменения online/offline состояния
    useEffect(() => {
        const handleOnline = () => {
            console.log("Интернет подключен.");
            // Возможно, принудительно обновить токен при возвращении в онлайн
            if (user) {
                user.getIdToken(true).then(newToken => {
                    setToken(newToken);
                    localStorage.setItem("access_token_esti", newToken);
                    console.log("Firebase токен обновлен после возвращения в онлайн.");
                }).catch(e => console.error("Ошибка обновления токена при возвращении в онлайн:", e));
            }
        };
        const handleOffline = () => console.log("Интернет отключен.");

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [user]); // Зависит от состояния пользователя

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
                <div className="text-center text-white">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 backdrop-blur-sm">
                        <span className="text-3xl font-bold">E</span>
                    </div>
                    <h2 className="text-2xl font-bold mb-3">Esti.kz</h2>
                    <p className="text-blue-100 mb-6">Авторизация тексерілуде...</p>
                    <div className="flex justify-center space-x-1">
                        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce"></div>
                        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ user, token }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);